export default "__VITE_ASSET__C1nkA$GH__"